import { Link } from 'react-router-dom';
import { tr, useLang } from '../lang';

export function NotFound() {
  useLang();
  return (
    <div className="page">
      <div className="page-head">
        <p className="kicker">404</p>
        <h1>{tr('Nothing written here · このページは見つかりません')}</h1>
      </div>
      <div>
        <Link className="btn" to="/board">
          {tr('Back to the board · ボードへ戻る')}
        </Link>
      </div>
    </div>
  );
}
